<template>
    <gofix-form-dropdown
        :vLabel="vLabel"
        :label="label" 
        :filterable="filterable" 
        :required="required"
        :show-icon-required="showIconRequired"
        :append-to-body="appendToBody"
        :disabled="disabled"
        :reduce="reduce"
        :options="computedOptions"
        @search="searchOptions"
        :value="value"
        @input="handleInput" >
        <template slot="gofixInput:dropdown:option"  slot-scope="option">
            {{option.user_name}} - {{option.user_email}}
        </template>
        <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
            {{option.user_name}} - {{option.user_email}}
        </template>
    </gofix-form-dropdown>
</template>

<script>
    export default {
        name: "dropdown-projects",
        props: {
            value: {
                required: true,
                default: () => null
            },
            projectId: {
                type: Number,
                required: false,
                default: null
            },
            companyId: {
                type: Number,
                required: false,
                default: null
            },
            roleName: {
                type: String,
                required: false,
                default: ''
            },
            serviceCategoryName: {
                type: String,
                required: false,
                default: 'WSH'
            },
            safetyOnlyFM: {
                type: Boolean,
                required: false,
                default: () => false
            },
            excludeId: {
                type: Number,
                required: false,
                default: null
            },
            vLabel: {
                type: String,
                required: false,
                default: () => "user_name"
            },
            label: {
                type: String,
                required: false,
                default: () => "Subcontractor Supervisor"
            },
            filterable: {
                type: Boolean,
                required: false,
                default: () => false
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            appendToBody: {
                type: Boolean,
                required: false,
                default: () => true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            reduce: {
                type: Function,
                default: option => option,
            },
        },

        data() {
            return {
                options: [],
                timer: null
            }
        },
        watch: {
            projectId: function() {
                this.getOptions()
            },
            companyId: function() {
                this.getOptions()
            },
            roleName: function() {
                this.getOptions()
            }
        },
        computed: {
            // Add computed properties here
            computedOptions() {
                let items = this.options
                if(items.length && this.excludeId) {
                    items = items.filter(item => item.user_id != this.excludeId)
                }
                return items
            }
        },
        created(){
            this.getOptions()
        },
        methods: {
            async getOptions(search = '') {
                if(!this.projectId) {
                    this.options = []
                    return
                }

                let filters = {
                    project_id: this.projectId, 
                    company_id: this.companyId,
                    service_category_name: this.serviceCategoryName,
                    role_name: this.roleName,
                    user_name: search,
                }

                if(this.companyId) {
                    filters.company_id = this.companyId
                }

                let request = {
                    filter: filters,
                    safetyOnlyFM: this.safetyOnlyFM,
                    page: 1,
                    limit: 100
                };
                this.$store.dispatch("SafetyAppController/getUserDuties", request)
                    .then(response => {
                        this.options = response.items;
                    })
                    .catch(err => {})
            },
            async searchOptions(search, loading) {
                loading(true)
                this.options = []
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOptions(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
        }
    }
</script>

<style scoped>

</style>
